import React, { FunctionComponent } from 'react';
import { Icon } from 'rs-emd-ui-atoms';
import { ILabel } from '../../../models/common/label.model';
import { IStock } from '../../../models/common/stock.model';
import styles from './dtp-stock-message-component.module.scss';

export type DTPStockMessageProps = {
  labels?: ILabel[] | null;
  stockArea?: IStock | null;
  showBullets?: boolean;
};

export const DTPStockMessage: FunctionComponent<DTPStockMessageProps> = ({ showBullets = false, ...props }) => {
  const hasStockMessage = props.stockArea?.dtpStockMessages && props.stockArea?.dtpStockMessages.length > 0;

  const hasInfoMessage = props.stockArea?.infoMessage && props.stockArea?.infoMessage?.length > 0;

  return hasStockMessage || hasInfoMessage ? (
    <div className={styles['dtp-stock-message-container']}>
      {hasStockMessage && (
        <div className={showBullets ? styles['bullet-schedule'] : ''}>
          {props.stockArea?.dtpStockMessages?.map((msg) => {
            // If not showing stock message in the stock badge (not StockStatus.Error) capitalize first letter of message
            let updatedMsg = msg[0] === '<' ? msg : msg[0].toUpperCase() + msg.substring(1);

            if (showBullets) {
              return (
                <div className={styles['bullet-info']}>
                  <Icon name='circle-fill' className={styles.bullet} />
                  <p className={styles['stock-message']} dangerouslySetInnerHTML={{ __html: updatedMsg }} />
                </div>
              );
            } else {
              return <p className={styles['stock-message']} dangerouslySetInnerHTML={{ __html: updatedMsg }} />;
            }
          })}
        </div>
      )}
      {hasInfoMessage && <p className={styles['dtp-info']}>{props.stockArea?.infoMessage}</p>}
    </div>
  ) : (
    <></>
  );
};

export default DTPStockMessage;
